import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to LockWise",
    title: "24/7 Lockout Assistance {& Security Solutions}",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to LockWise",
    title: "Expert Residential & Commercial {Locksmith Services}",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to LockWise",
    title: "Emergency {Locksmith Services for Swift Response}",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
];

export default home;